import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-thread-skeleton',
    standalone: true,
    imports: [CommonModule, SkeletonModule],
    templateUrl: './thread-skeleton.component.html',
    styleUrl: './thread-skeleton.component.scss'
})
export class ThreadSkeletonComponent {
    isSidePanelOpen = input<boolean>(false);
    messageCount = input<number>(3);

    getMessageArray(): number[] {
        return Array.from({ length: this.messageCount() }, (_, i) => i);
    }
}
